var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Col } from "react-bootstrap";
import { Card } from "@irati/ui/src/Layout";
export var StyledCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 30px;\n  margin-right: 15px;\n"], ["\n  width: 30px;\n  margin-right: 15px;\n"])));
export var UnavailableCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "background-color: " + theme.colors.greys.mediumLight + ";";
});
var templateObject_1, templateObject_2;
